import RewardServiceApp from '@repo/reward-service/RewardServiceApp';

function App() {
  return <RewardServiceApp />;
}

export default App;
